import type { NitroFetchRequest, TypedInternalResponse } from 'nitropack'
import type { SafeParseError, ZodIssue } from 'zod'

export class HttpError extends Error {
  constructor(
    message: string,
    public status: number,
    public statusText: string,
    public url: string,
    public method: string,
    public responseData: TypedInternalResponse<any, any>
  ) {
    super(message)
    Error.captureStackTrace(this, HttpError)
  }
}

export class SchemaError extends Error {
  constructor(
    message: string,
    public data: any,
    public issues: ZodIssue[]
  ) {
    super(message)
    Error.captureStackTrace(this, SchemaError)
  }
}

export class ApiValidationError extends Error {
  constructor(
    public errorData: {
      data: any
      response: TypedInternalResponse<any, any>
      request: NitroFetchRequest
      apiUrl: string
      result: SafeParseError<any>
    }
  ) {
    super('API 資料型別驗證錯誤')
    Error.captureStackTrace(this, ApiValidationError)
  }
}
